import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import PortalIdParser from 'PortalIdParser';
import UIBadge from 'UIComponents/badge/UIBadge'; // @ts-expect-error cannot find declaration file

import { trackEvent } from 'AdsUI/lib/usageTracker';
const successParameter = 'success=true';
const cancelParameter = 'goalCancelled=true';

const CreateGoalButton = () => {
  const PORTAL_ID = PortalIdParser.get();
  let cancelRedirectUrl = window.location.href;

  if (cancelRedirectUrl.indexOf('?') > -1) {
    cancelRedirectUrl += `&${cancelParameter}`;
  } else {
    cancelRedirectUrl += `?${cancelParameter}`;
  }

  return /*#__PURE__*/_jsx(UIButton, {
    use: "secondary",
    href: `${window.location.origin}/goals/${PORTAL_ID}/create/1?goalCategory=marketing&redirectUrl=${encodeURIComponent(`${window.location.origin}/ads/${PORTAL_ID}/goals?${successParameter}`)}&cancelRedirectUrl=${encodeURIComponent(cancelRedirectUrl)}`,
    onClick: () => trackEvent('goalCreationAction', {
      action: 'Clicked create goal'
    }),
    size: "small",
    children: /*#__PURE__*/_jsxs("div", {
      className: "align-center",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "createDropdown.goal",
        className: "m-right-2"
      }), /*#__PURE__*/_jsx(UIBadge, {
        use: "new",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "new"
        })
      })]
    })
  });
};

export default CreateGoalButton;